import { type FC, useCallback, useMemo } from 'react';

import { ImageComponent } from '@/components/Image';
import { useCMSConfig } from '@/modules/common';
import { useVIP } from '@/modules/vip/hooks/useVIP';
import { useGetCommonStore } from '@/store';
import { ScAnimatedLogo, ScLogo } from './styled';

export const Logo: FC = () => {
  const useCommonStore = useGetCommonStore();

  const isAuthenticated = useCommonStore.use.isAuthenticated();
  const isMobileDevice = useCommonStore.use.isMobileDevice();

  const { brandAssets } = useCMSConfig();

  const isLogoMin = useMemo(
    () => isAuthenticated || isMobileDevice,
    [isAuthenticated, isMobileDevice]
  );

  const { isVip } = useVIP();

  const getPromoLogo = useCallback(() => {
    if (!brandAssets) return;

    const logoFromCms = isLogoMin
      ? brandAssets?.logoMobile?.url
      : brandAssets?.logoDesktop?.url;

    if (!logoFromCms) return;

    return brandAssets?.animatedLogo ? (
      <ScAnimatedLogo>
        <object aria-label="Level Up" data={logoFromCms} height={32} />
      </ScAnimatedLogo>
    ) : (
      <ImageComponent
        alt="Level Up"
        height={40}
        src={logoFromCms}
        width={isLogoMin ? 48 : 140}
      />
    );
  }, [brandAssets, isLogoMin]);

  const getVipLogo = useCallback(() => {
    if (!(brandAssets?.vipAnimatedLogo && isVip)) return;

    return (
      <ScAnimatedLogo>
        <object
          aria-label="Level Up"
          data={brandAssets?.vipAnimatedLogo?.url || ''}
          height={32}
        />
      </ScAnimatedLogo>
    );
  }, [brandAssets, isVip]);

  return getPromoLogo() || getVipLogo() || <ScLogo logoMin={isLogoMin} />;
};
